/* -------------------------------------------------------------------------- */
/*                               Schema Locations                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const location = new schema.Entity('locations', {}, { idAttribute: 'locationId' });
export const locations = new schema.Array(location);
